import type { MigrateSingleShare, MigrateVaultShareEnriched, ResponseMigrateStart } from "@/features/migrate/types/api";

import { useMemo } from "react";

import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import useApi from "@/hooks/api/useApi";

interface RequestParams {
  simulate?: boolean;
  need_approval?: boolean;
}

/**
 * @package api:v1:deposit
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/31612773-1f79cf00-1945-4132-974e-33c9f6b8f2c9?action=share&source=copy-link&creator=26633220
 */
export default function useMigrateStart(vaultShares: MigrateVaultShareEnriched[] | undefined = undefined, simulate: boolean = true, requireApproval: boolean = true) {
  const userAddress = useWeb3UserAddress();

  const preparedParams = useMemo<RequestParams>(
    () => ({
      simulate,
      need_approval: requireApproval,
    }),
    [requireApproval, simulate]
  );

  const preparedData = useMemo<MigrateSingleShare[] | undefined>(() => {
    if (!userAddress || !vaultShares || vaultShares.length < 1) {
      return undefined;
    }
    return vaultShares.map(
      share =>
        ({
          user_address: userAddress,
          superform_id: share.superform_id,
          amount: share.balance,
          slippage: 50, // TODO: confirm about this value
        }) as MigrateSingleShare
    );
  }, [userAddress, vaultShares]);

  const { data, error, isLoading, isError, mutate } = useApi<ResponseMigrateStart, ResponseMigrateStart>(
    {
      path: "/migrate/start/",
      api: "v2",
      data: preparedData,
      params: preparedParams,
      method: "POST",
    },
    {
      enabled: Boolean(preparedData),
      strategy: "on-mount",
      select: data => {
        console.log("data from /migrate/start/", data);
        return data;
      },
    }
  );

  return {
    data,
    error,
    isLoading,
    isError,
    mutate,
  };
}
